import React from 'react';

import { SiteNav } from '../../components/SiteNav/SiteNav';
import { SiteFooter } from '../../components/SiteFooter/SiteFooter';
import { FaqSection } from '../../components/FaqSection/FaqSection';
import { BrandPromoSection } from './BrandPromoSection';
import { Carousel } from './Carousel';
import { HowItWorksSection } from './HowItWorksSection';
import { IntroSection } from './IntroSection';
import { TestimonialsSection } from './TestimonialsSection';
import type { BrandPromo, Faq, Intro, Slide, Step, Testimonials } from './slides';

type ForAthleteProps = {
    csrfToken: string;
    slides: Slide[];
    intro: Intro;
    steps: Step[];
    brandPromo: BrandPromo;
    testimonials: Testimonials;
    faq: Faq;
};

export function ForAthlete({ csrfToken, slides, intro, steps, brandPromo, testimonials, faq }: ForAthleteProps) {
    return (
        <div className="for-athlete">
            <Carousel slides={slides} nav={<SiteNav />} />
            <IntroSection data={intro} />
            <HowItWorksSection steps={steps} />
            <BrandPromoSection data={brandPromo} />
            <TestimonialsSection data={testimonials} />
            <FaqSection data={faq} />
            <SiteFooter csrfToken={csrfToken} />
        </div>
    );
}
